import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getCompaniesQueryOptions } from '@/_pages/companies/api-service';

export const Route = createFileRoute('/_private/companies/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompaniesQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={8} />,
});
